import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {store, persistor} from '../src/store/';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Páginas
import Login from './view/login/';
import Register from './view/register/';
import Home from './view/appHome/';
import DocsRegister from './view/docs-register/';
import RecPassword from './view/rec-password/';

function App(){
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router basename="/sistema">
          <Route exact path='/' component={Login} />
          <Route exact path='/registro-seguro' component={Register} />
          <Route exact path='/mudar-senha' component={RecPassword} />
          <Route exact path='/home' component={Home} />
          <Route exact path='/registro-de-documento' component={DocsRegister} />
        </Router>
      </PersistGate>
    </Provider>
  )
}

export default App
